import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAwcnZ-NFwr89nbcoY0iIjsm3LvuaWWsUQ",
  authDomain: "start-skipres.firebaseapp.com",
  projectId: "start-skipres",
  storageBucket: "start-skipres.firebasestorage.app",
  messagingSenderId: "187338605444",
  appId: "1:187338605444:web:df937a3394ee52ede593d1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
